<template>
  <div>
      <div class="flowPath" v-if="show">
          <div class="flowItme" :class="index > 0 ? 'mt_10' : ''" v-for="(item, index) in progressList" :key="index">
            <div class="flowIn flowInleft" >
              <div v-show="index%2==0" class="left">
                <div class="flowText1">{{item.name}}</div>
                <div class="flowText2">{{item.title}}</div>
                <div class="flowText2">{{item.matchTime}}</div>
                <div class="flowText3" v-html="item.intro"></div>
              </div>
              <div v-show="index%2==0" class="circularleft">
                <div class="circular" :style="{'background': colorList[index]}"></div>
              </div>
            </div>
            <div class="flowIn flowInright" >
              <div v-show="index%2==1" class="circularright">
                <div class="circular" :style="{'background': colorList[index]}"></div>
              </div>
              <div v-show="index%2==1" class="right">
                <div class="flowText1">{{item.name}}</div>
                <div class="flowText2">{{item.title}}</div>
                <div class="flowText2">{{item.matchTime}}</div>
                <div class="flowText3" v-html="item.intro"></div>
              </div>
            </div>
          </div>
      </div>

      <div class="flowPath2" v-if="progressList.length <6 && !show">
        <div class="flowItemBox" v-for="(item, index) in progressList" :key="index">
          <div class="flowItemTop">
            <div class="flowText1" v-show="index%2==0 || progressList.length < 4">{{item.name}}</div>
            <div class="flowText2" v-show="index%2==0 || progressList.length < 4">{{item.title}}</div>
            <div class="flowText3 mb_10" v-show="index%2==0 || progressList.length < 4">{{ item.matchTime}}</div>
            <div class="circularbottom" v-show="index%2==0 || progressList.length < 4">
                <div class="circular" :style="{'background': colorList[index]}"></div>
              </div>
          </div>
          <div class="flowItemBottom" v-if="progressList.length >=4">
            <div class="circulartop" v-show="index%2==1">
              <div class="circular" :style="{'background': colorList[index]}"></div>
            </div>
            <div class="flowText1" v-show="index%2==1">{{item.name}}</div>
            <div class="flowText2" v-show="index%2==1">{{item.title}}</div>
            <div class="flowText3 mb_10" v-show="index%2==1">{{ item.matchTime}}</div>
          </div>
        </div>
      </div>
  </div>

</template>
<script>
export default {
  props:['progressList','show'],
  data() {
    return {
      colorList:['#3BDF9B','#4F90FD','#EFB734','#3BDF9B','#4F90FD','#EFB734']
    }
  },
}
</script>
<style scoped>
.flowPath{
  width: 70%;
  margin: 0 15%;
  margin-top: 60px;
}
.flowPath .flowItme{
  display: flex;
  text-align: left;
}
.mt_10{
  margin-top: -5%;
}
.flowIn{
  flex-basis: 50%;
}
.flowInleft{
  border-right: 1px solid #ffffff;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  justify-content: flex-end;
}
.flowInright{
  border-left: 1px solid #ffffff;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  justify-content: flex-start;
}
.circularleft{
  z-index: 1;
  margin-right: -9px;
  margin-left: 37px;

}
.circularright{
  z-index: 1;
  margin-left: -9px;
  margin-right: 44px;
}
.circular{
  width: 16px;
  height: 16px;
  background: #3BDF9B;
  border-radius: 50px;
}
.flowText1{
  font-weight: 600;
  font-size: 24px;
  color: #FFFFFF;
  line-height: 32px;
}
.flowText2{
  font-weight: 600;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 18px;
  margin: 20px 0;
}
.flowText3{
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 26px;
  max-width: 490px;
  word-break: break-all;
}
.flowPath2{
  display: flex;
  width: 70%;
  margin: 75px 15%;
}
.flowPath2 .flowItemBox{
  flex: 1;
  text-align: center;
}
.flowPath2 .flowItemBox .flowItemTop{
  border-bottom: 1px solid #ffffff;
  min-height: 185px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.mb_10{
  margin-bottom: 10px;
}
.circularbottom{
  z-index: 1;
  margin-bottom: -9px;
  display: flex;
  justify-content: center;
}
.flowItemBottom{
  border-top: 1px solid #ffffff;
  min-height: 185px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.circulartop{
  z-index: 1;
  margin-top: -9px;
  display: flex;
  justify-content: center;
}
@media screen and (max-width: 1100px) {
  .flowText1{
    font-weight: 600;
    font-size: 20px;
    color: #FFFFFF;
    line-height: 32px;
  }
  .flowText2{
    font-weight: 600;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 18px;
    margin: 20px 0;
  }
  .flowText3{
    font-weight: 400;
    font-size: 10px;
    color: #FFFFFF;
    line-height: 26px;
    max-width: 490px;
    word-break: break-all;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/flow.vue